module.exports = __webpack_public_path__ + "7a93202599bfd543ed3401d92f2e95e3.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CK.svg
// module id = s7/r
// module chunks = 0